export const STORAGE_KEY_PENDING_SEARCHSPRING_ANCHOR = 'ss_pending_searchspring_plp_anchor'

export const STORAGE_KEY_SKIP_RESULTS_IN_VIEW_SCROLL = 'ss_skip_results_inview_scroll'

export function markPlpFacetFilterInteraction() {
  if (typeof sessionStorage === 'undefined') return
  sessionStorage.setItem(STORAGE_KEY_PENDING_SEARCHSPRING_ANCHOR, '1')
  sessionStorage.setItem(STORAGE_KEY_SKIP_RESULTS_IN_VIEW_SCROLL, '1')
}

let facetFilterScrollCaptureInstalled = false

function handleFacetFilterInteractionCapture(event) {
  if (event.target.closest('a.ss__featured-filter')) {
    markPlpFacetFilterInteraction()
    return
  }

  const optionsRoot = event.target.closest('.ss__facet__options')
  if (!optionsRoot) return

  const link = event.target.closest('a')
  if (!link || !optionsRoot.contains(link)) return

  markPlpFacetFilterInteraction()
}

export function installPlpFacetFilterScrollCapture() {
  if (facetFilterScrollCaptureInstalled || typeof document === 'undefined') return
  facetFilterScrollCaptureInstalled = true

  document.addEventListener('click', handleFacetFilterInteractionCapture, true)
}
